module.exports = __webpack_public_path__ + "static/media/quality3.7d9e4496.jpg";